import { useState } from "react"
import { TFilters } from "../../../../../components/TableDataGridV2/types"
import {Box, Button, Container, Grid, MenuItem, TextField} from "@mui/material"
import SelectIngredienteAtivoMultiple from "../../../../../components/SelectsSimpleApiQuery/SelectIngredienteAtivo/Multiple";

export default function PreFiltros({
                                       filtros,
                                       onSubmitFilters
                                   }: PreFiltrosProps) {

    const [internFilters, setInternFilters] = useState(filtros)
    const [ingredienteAtivo, setIngredienteAtivo] = useState<any>(null)

    const filtrarObj = (obj: TFilters) => {
        const novoObjeto: TFilters = { ...obj };

        Object.keys(novoObjeto).forEach((key) => {
            if (key.startsWith('codigo_agrotoxico')) {
                novoObjeto.id_contem = [novoObjeto[key]];
                delete novoObjeto[key];
            }
            if (key.startsWith('organico')) {
                novoObjeto.organico_igual = novoObjeto[key];
                delete novoObjeto[key];
            }
        });

        // Add ingrediente_ativo_id_pesquisar if selected
        if (ingredienteAtivo) {
            const id = Array.isArray(ingredienteAtivo) ? ingredienteAtivo[0]?.id : ingredienteAtivo?.id;
            if (id) {
                novoObjeto.ingrediente_ativo_id_pesquisar = id;
            }
        }

        return novoObjeto;
    };

    const handleInsertFiltros = (prop: string, value: any) => {
        setInternFilters(prevState => ({ ...prevState, [prop]: value }))
    }

    const handleSubmit = () => {
        const formatValue = filtrarObj(internFilters)
        onSubmitFilters(formatValue)
    }

    return (
        <Container maxWidth="md" sx={{ py: 2 }}>
            <Grid container spacing={2}>
                <Grid size={{xs: 12, md: 12}}>
                    <TextField
                        label="Marca Comercial"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("marca_comercial_pesquisar", e.target.value)
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Código"
                        variant="outlined"
                        type="number"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("codigo_agrotoxico_pesquisar", e.target.value)
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <SelectIngredienteAtivoMultiple
                        unique_select={true}
                        value={ingredienteAtivo}
                        onChange={setIngredienteAtivo}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Titular do Registro"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("titular_registro_pesquisar", e.target.value)
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Classe"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("classe_pesquisar", e.target.value)
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        label="Modo de Ação"
                        variant="outlined"
                        fullWidth
                        onChange={(e) => {
                            handleInsertFiltros("modo_acao_pesquisar", e.target.value)
                        }}
                    />
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <TextField
                        select
                        label="Orgânico"
                        variant="outlined"
                        fullWidth
                        value={internFilters.organico || ""}
                        onChange={(e) => handleInsertFiltros("organico", e.target.value)}
                    >
                        <MenuItem value="">Selecione</MenuItem>
                        <MenuItem value="NAO">NÃO</MenuItem>
                        <MenuItem value="SIM">SIM</MenuItem>
                        <MenuItem value="OUTROS">OUTROS</MenuItem>
                    </TextField>
                </Grid>
            </Grid>
            <Box mt={2}>
                <Button
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Pesquisar
                </Button>
            </Box>
        </Container>
    )
}

interface PreFiltrosProps {
    filtros: TFilters,
    onSubmitFilters: (args: TFilters) => void
}